import React__default from 'react';

var WebLobbyColumn = function (_a) {
    var children = _a.children, _b = _a.position, position = _b === void 0 ? 'left' : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    if (position === 'left') {
        return React__default.createElement("div", { className: 'lobby-left-item-content' }, children);
    }
    return (React__default.createElement("div", { className: 'lobby-inside-right-ins' },
        React__default.createElement("div", { className: "lobby-right-content ".concat(className) }, children)));
};

export { WebLobbyColumn };
